/**
 * @owner @Appboy/operator
 * @fileoverview GET handler for the "/dust/auth/:app_group_id" endpoint
 */

import type { DustConfigResponse } from "@lib/dust";
import fetch, { encodeParams } from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { RootCacheKey } from "../types";
import { cacheKey } from "./constants";

type GetDustConfigArgs = [appGroupId: string] | [appGroupId: string, tabIdentifier: string];

export const getDustConfig = reactQueryFetcherAdapter<
  typeof cacheKey,
  readonly [rootKey: RootCacheKey<typeof cacheKey>, ...originalKey: GetDustConfigArgs],
  GetDustConfigArgs,
  DustConfigResponse
>(
  cacheKey,
  (signal: AbortSignal, ...[appGroupId, tabIdentifier]: GetDustConfigArgs): Promise<DustConfigResponse> => {
    // tabIdentifier is salted into the derived session id backend-side so each
    // tab gets a distinct, session-targeted MITE, avoiding cross-tab MITE
    // conflicts on a single shared identifier.
    const queryParams: Record<string, string> = {};
    if (tabIdentifier) {
      queryParams.tabIdentifier = tabIdentifier;
    }
    const query = Object.keys(queryParams).length > 0 ? `?${encodeParams(queryParams)}` : "";
    const url = `/dust/auth/${appGroupId}${query}`;
    return fetch(url, "GET", undefined, { signal });
  }
);
